import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ImportService } from '@app/core/services/import.service';
import * as _ from 'lodash';
import { ImportDetailModel } from '@app/core/models/imports/import-detail.model';

@Injectable({ providedIn: 'root' })
export class ImportDetailsResolver  {
  constructor(private importService: ImportService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<ImportDetailModel[]> | Promise<ImportDetailModel[]> | ImportDetailModel[] {
    const importId = route.params.id;

    return this.importService.getImportDetails(importId);
  }
}
